import { render, staticRenderFns } from "./ProductDocumentsForm.vue?vue&type=template&id=433fed3a&lang=pug"
import script from "./ProductDocumentsForm.vue?vue&type=script&lang=js"
export * from "./ProductDocumentsForm.vue?vue&type=script&lang=js"
import style0 from "./ProductDocumentsForm.vue?vue&type=style&index=0&id=433fed3a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports